import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const rawLang = localStorage.getItem("lang");
const initialLang = rawLang === "my" ? "en" : (rawLang || "en");
if (rawLang === "my") {
  localStorage.setItem("lang", "en");
}

const i18n = new VueI18n({
  locale: initialLang,
  fallbackLocale: "en",
  silentFallbackWarn: true,
  messages: {
    zh: require("./lan/zh"), // 中文语言包
    en: require("./local_en"), // 英文语言包
    in: require("./local_in"),
    my: require("./local_my"),
    ph: require("./local_ph"),
    th: require("./local_th"),
    vn: require("./local_vn"),
    ru: require("./local_ru")
  }
});

export default i18n;
